import classNames from "classnames";
import React from "react";
import styles from "./Button.module.css";

interface Props {
  icon: string | React.ReactNode;
  altText: string;
  onClick: () => void;
  className?: string;
}

// TODO: This component needs an option to set text and background color
export const IconButton: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  icon,
  altText,
  onClick,
}) => {
  return (
    <button
      className={classNames(styles.iconButton, className)}
      onClick={onClick}
    >
      {typeof icon === "string" ? (
        <img src={icon} alt={altText} className={styles.icon} />
      ) : (
        icon
      )}
    </button>
  );
};
